import React, { useContext } from "react";
import styled from "styled-components";
import DigitalCompanyCardContext from "src/scenes/DigitalMemberCard/DigitalCompanyCardContext";
import pluralize from "pluralize";
import { customNames } from "src/utils/helpers";

const CardContainer = styled.div`
    background-color: ${ p => p.backgroundColor };
    box-shadow: 0px 5px 10px #00000033;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    width: 270px;
    text-align: left;
`;

const CardHeader = styled.div`
    display: flex;
    flex-direction: row;
    color: #FFF;
    padding: 10px;

    & > div {
        width: 50%;
    }
`;

const AppleCardHeroContainer = styled.div`
    height: 105px;
    border-color: rgba(255, 255, 255, 0.4);
    border-style: solid;
    border-width: 1px 0px 0px 0px;

    /** image settings */
    background-image: url("${ p => p.cardHeroImage }");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const CardInformation = styled.div`
    padding: 10px 10px 0px 10px;

    display: flex;
    flex-wrap: wrap; /* Allows items to wrap onto new lines */

    //direct div container
    > div:nth-child(1) {
        width: 60%;
    }

    > div:nth-child(2) {
        width: 40%;
    }

    border-color: rgba(255, 255, 255, 0.4);
    border-style: solid;
    border-width: ${ p => p.hasCardHeroImage ? "1px 0px 0px 0px" : "0px" };
`;

const QRCodeContainer = styled.div`
    padding-top: 30px;
    padding-bottom: 30px;
    display: grid;
    justify-items: center;

    border-color: rgba(255, 255, 255, 0.4);
    border-style: solid;
    border-width: 1px 0px 0px 0px;
`;

const QrCode = styled.div`
    width: 108px;
    height: 108px;
    border: 1px solid #FFF;
    border-radius: 5px;
`;

const DesignationGrid = styled.div`
    margin-bottom: 10px;
`;

const Designation = styled.div`
    font-size: 0.625rem;
    color: ${p => p.color || "#FFFFFF" };
    font-weight: 500;
    text-transform: ${p => p.textTransform || "uppercase" };
`;

const AssignedValue = styled(Designation)`
    font-weight: 300;
    text-transform: capitalize;
    margin-top: 5px;
`;

const ImageContainer = styled.div`
    height: 31px;
    width: 79px;
    display: flex; 
    justify-content: flex-start; 
    align-items: center;

    > img {
        max-width: 100%;
        max-height: 100%;
    }
`;

const EmployeeAppleCard = ({ isTemplateForClientPreview, cardPreviewBackgroundColor, cardPreviewHeroImage, cardPreviewTextColor }) => {
    
    const {
        getCardTemplateByUserType,
        employeeCardInfo,
        clientCardInfo,
        digitalMembershipCards
    } = useContext(DigitalCompanyCardContext);

    const cardTemplate = getCardTemplateByUserType(isTemplateForClientPreview);
    const textColor = cardPreviewTextColor ? cardPreviewTextColor : cardTemplate.textColor;
    const hasCardHeroImage = cardPreviewHeroImage === null ? false : (cardPreviewHeroImage || cardTemplate.cardHeroImage);
    const userCardInfo = isTemplateForClientPreview ? clientCardInfo : employeeCardInfo;
    
    return (
        <CardContainer backgroundColor={cardPreviewBackgroundColor ? cardPreviewBackgroundColor : cardTemplate.backgroundColor}>
            <CardHeader>
                <ImageContainer>
                    <img src={cardTemplate.logo} alt="Business Logo" />
                </ImageContainer>
                <div style={{ textAlign: "right" }}>
                    <Designation color={textColor}>{ isTemplateForClientPreview ? `${pluralize.singular(customNames.clients.toUpperCase())} ID` : `${pluralize.singular(customNames.employees.toUpperCase())} ID` }</Designation>
                    <AssignedValue color={textColor}># {userCardInfo.cardId}</AssignedValue>
                </div>
            </CardHeader>
            { hasCardHeroImage && <AppleCardHeroContainer cardHeroImage={cardPreviewHeroImage ? cardPreviewHeroImage : cardTemplate.cardHeroImage} /> }
            <CardInformation hasCardHeroImage={hasCardHeroImage}>
                <div>
                    <DesignationGrid>
                        <Designation color={textColor}>NAME</Designation>
                        <AssignedValue color={textColor}>{ userCardInfo.fname } { userCardInfo.lname }</AssignedValue>
                    </DesignationGrid>
                    <DesignationGrid>
                        <Designation textTransform="capitalize" color={textColor}>{ isTemplateForClientPreview ? `${pluralize.singular(customNames.clients.toLowerCase())} type` : "TITLE" }</Designation>
                        <AssignedValue color={textColor}>{ userCardInfo.titleOrClientType }</AssignedValue>
                    </DesignationGrid>
                </div>
                
                <div>
                    <DesignationGrid>
                        <Designation color={textColor}>MEMBER SINCE</Designation>
                        <AssignedValue color={textColor}>{ userCardInfo.memberSince }</AssignedValue>
                    </DesignationGrid>
                </div>
            </CardInformation>
            <QRCodeContainer>
                <QrCode><img src={digitalMembershipCards.qrImage} alt="Public Contract QR Code" style={{ width: "100%" }}/></QrCode>
            </QRCodeContainer>
        </CardContainer>
    );
};
export default EmployeeAppleCard;